import { FileText } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router-dom'
import { PageShell } from '@/components/layout/PageShell'
import { Card } from '@/components/ui/card'
import { ReportExportButton, type ReportOutletContext } from '../../ReportLayout'

export default function ReportEvidencePage() {
  const { t } = useTranslation()
  const { handleExportPdf, isGeneratingReport } = useOutletContext<ReportOutletContext>()
  return (
    <PageShell
      layout="padded"
      icon={FileText}
      title={t('cases.report.evidence.title')}
      summary={t('cases.report.evidence.summary')}
      toolbar={<ReportExportButton onExport={handleExportPdf} isExporting={isGeneratingReport} />}
    >
      <Card className="p-6">
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <FileText className="size-8 text-muted-foreground mb-2" />
          <p className="text-sm font-medium text-foreground">Evidence Package</p>
          <p className="text-xs text-muted-foreground mt-1">
            Collect and organize evidence documents for export. Coming soon.
          </p>
        </div>
      </Card>
    </PageShell>
  )
}
